import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import AccountRepository from './AccountRepositoryImpl';

const accountRepository = new AccountRepository(fetcherAmplify);
export { accountRepository };
